import React from "react";
import { PropTypes } from "prop-types";
import { map, clone } from 'lodash';
import { HeadKeyStyle, HeadValueStyle } from "../../styles";
import {
  MainHead,
  SubHead,
  SubHeadTitle,
  ImageWrap,
  KeyStyle,
  ValueStyle,
  PhoneInfoWrapMain,
  PhoneInfoWrap,
  AdressInfoInner,
  AdressInfoWrap,
  GhostButtonComponentStyles,
  DeliveryWrap,
  BorderRight,
  AddMarginSpace,
  ValueStylePrimary
} from "./styles";
import { connect } from "react-redux";
import moment from "moment";
import { Row, Col } from "antd";
import phoneIcon from "../../../../../../assets/icons/phone.svg";
import addressIcon from "../../../../../../assets/icons/addresses.svg";
import emailIcon from "../../../../../../assets/icons/email.svg";
import DeliverprefIcon from "../../../../../../assets/icons/delivery-preference.svg";
import {
  filterDataWithValue
} from "../../../Data/FilterDropDownData";
import {
  EllipsisDataValueWrapper, EllipsisContent, EllipsisUnderline
} from "../../../../../../CommonComponents/commonStyles";
import * as CustomPropTypes from '../../../DefaultPropTypes';
import { DetailsDerivedStates } from "../../../selectors";

export const viewPhoneNumber = (phoneNumbers=[]) => {  
  let phoneInfo = [];
  if(phoneNumbers && phoneNumbers.length === 3) {
    phoneInfo = map(phoneNumbers, clone).sort((a, b) => b.phonetype.toLowerCase() - a.phonetype.toLowerCase());    
    const otherIndex = phoneInfo.findIndex(i => i.phonetype.toLowerCase() === 'other');
    if(otherIndex == 1) {    
      phoneInfo.push(phoneInfo.splice(1, 1)[0]);      
    }
  } else {
    phoneInfo = phoneNumbers;
  }
  
  return (
    <PhoneInfoWrapMain>
      {phoneInfo && phoneInfo.hasOwnProperty('length') && phoneInfo.map( (val, index) => (
        val.phonenumber.trim() && (
        <PhoneInfoWrap data-test="phoneWrapper" key={`phone_${index}`}>
          <KeyStyle lineHeight="2">{val.phonetype}: </KeyStyle>&nbsp;
          <ValueStyle lineHeight="2">{val.phonenumber}</ValueStyle>{" "}
        </PhoneInfoWrap> )
      ))}
    </PhoneInfoWrapMain>
  )
}

export const Details = props => {
  let len = props.addressInfo && props.addressInfo.length;
  let count = 0;
  let countAddress = 0;

  const getFormattedDOB = () => {
    let dob = new Date(props.basicInfo.dob).toDateString();
    let dobDate = moment(dob);
    return moment(dobDate).format("MM/DD/YYYY");
  };

  const formatName = () => {
    const { firstname, middlename, lastname, title, suffix } = props.basicInfo;
    return `${title ? getValues(title, "title") : ""} ${
      firstname ? firstname : ""
    } ${middlename ? middlename : ""} ${lastname ? lastname : ""}${
      suffix ? `, ` + getValues(suffix, "suffix") : ""
    }`;
  };

  const deliveryMethod = () => {
    if(props.basicInfo.deliveryMethod === "E-Delivery"){
      return "E-Delivery";
    }else{
      if(props.basicInfo.deliveryMethod === "Paper"){
        return "Paper delivery";
      }
      return "U.S. mail with email notification";
    }
  }

  const getValues = (value, type) => {
    let val = "";
    if (type === "country") {
      val = filterDataWithValue(value, props.countryDropdown);
    } else if (type === "title") {
      val = filterDataWithValue(value, props.titleDropdown);
    } else if (type === "gender") {
      val = filterDataWithValue(value, props.genderDropdown);
    } else if (type === "suffix") {
      val = filterDataWithValue(value, props.suffixDropdown);
    }
    if (val.length > 0) {
      return val[0].desc;
    } else return undefined;
  };  

  return (
    <div>
      {props.header == "Primary Advisor" ? (
        <MainHead data-test="PrimaryAdvHeader" role={false} paddingTop="0">{props.header}</MainHead>
      ) : (
        <MainHead data-test="SecondaryAdvHeader" paddingTop="20px">{props.header}</MainHead>
      )}

      <SubHead>{formatName()}</SubHead>
      {
        props.basicInfo && props.basicInfo.gender ? (
          <>
            <HeadKeyStyle marginProp="0 7px 10px 0">Gender: </HeadKeyStyle>
            <HeadValueStyle>
              {getValues(props.basicInfo.gender, "gender")}
            </HeadValueStyle>
          </>
        ) : null
      }
      {/* <div className="npa_step3_personalinfo_dob_margin"> */}
      <AddMarginSpace>
        <HeadKeyStyle marginProp="0 7px 30px 0">Date of Birth:</HeadKeyStyle>
        <HeadValueStyle>{getFormattedDOB()}</HeadValueStyle>
      </AddMarginSpace>
      {/* </div> */}
      <Row>
        <Col lg={{ span: 10 }} md={{ span: 10 }}>
          <BorderRight>
            <SubHeadTitle>
              <ImageWrap src={phoneIcon}  alt="Phone"  />
              Phone number
            </SubHeadTitle>
            {viewPhoneNumber(props.phoneInfo)}
            <SubHeadTitle>
              <ImageWrap src={emailIcon}  alt="Email-Id"  />
              Email
            </SubHeadTitle>
            <PhoneInfoWrapMain>
              {props.emailInfo.map(val => (
                <PhoneInfoWrap>
                  {val.emailId && 
                    <>
                      <KeyStyle lineHeight="2">{val.emailtype}:</KeyStyle>&nbsp;
                      <ValueStyle lineHeight="2">
                      <EllipsisDataValueWrapper>
                          <EllipsisUnderline>{val.emailId}</EllipsisUnderline>
                          <EllipsisContent>                  
                              {val.emailId}
                          </EllipsisContent>
                      </EllipsisDataValueWrapper>  
                      </ValueStyle>{" "}
                      
                    </>
                  }
                </PhoneInfoWrap>
              ))}
            </PhoneInfoWrapMain>
            <DeliveryWrap>
              <SubHeadTitle>
                <ImageWrap src={DeliverprefIcon}  alt="Delivery" />
                Delivery Preference
              </SubHeadTitle>
              <PhoneInfoWrapMain>
                <PhoneInfoWrap>
                  <ValueStyle>
                    {deliveryMethod()}
                  </ValueStyle>
                </PhoneInfoWrap>
              </PhoneInfoWrapMain>
            </DeliveryWrap>
          </BorderRight>
        </Col>
        <Col lg={{ span: 12, offset: 1 }} md={{ span: 12, offset: 1 }}>
          <SubHeadTitle>
            <ImageWrap src={addressIcon}  alt="Address" />
            Addresses
          </SubHeadTitle>
          <Row>
            {props.addressInfo.map(val => {
              count = count + 1;
              if (count <= 2) {
                return (
                  <Col lg={{ span: 12 }} md={{ span: 12 }}>
                    <PhoneInfoWrapMain>
                      <AdressInfoWrap>
                        <AdressInfoInner>
                          <KeyStyle lineHeight="1.5">
                            {val.addresstype}:
                          </KeyStyle>
                          {val.primary ? (
                            <div>
                              <GhostButtonComponentStyles>
                                PRIMARY
                              </GhostButtonComponentStyles>
                            </div>
                          ) : null}{" "}
                        </AdressInfoInner>
                        <div>
                          <ValueStyle lineHeight="1.5">{val.line1},</ValueStyle>
                        </div>
                        {val.line2 ? (
                          <div>
                            <ValueStyle lineHeight="1.5">
                              {val.line2},
                            </ValueStyle>
                          </div>
                        ) : null}
                        {val.line3 ? (
                          <div>
                            <ValueStyle lineHeight="1.5">
                              {val.line3},
                            </ValueStyle>
                          </div>
                        ) : null}
                        <div>
                          <ValueStyle lineHeight="1.5">{val.city},</ValueStyle>
                          &nbsp;
                          <ValueStyle lineHeight="1.5">{val.state}</ValueStyle>
                          &nbsp;
                          <ValueStyle lineHeight="1.5">
                            {val.zipcode},
                          </ValueStyle>
                        </div>
                        <div>
                          <ValueStyle lineHeight="1.5">
                            {getValues(val.country, "country")}
                          </ValueStyle>
                        </div>
                      </AdressInfoWrap>
                    </PhoneInfoWrapMain>
                  </Col>
                );
              } else return false;
            })}
          </Row>
          <Row>
            {len > 2
              ? props.addressInfo.map(val => {
                  countAddress = countAddress + 1;
                  if (countAddress > 2) {
                    return (
                      <Col lg={{ span: 12 }} md={{ span: 12 }}>
                        <PhoneInfoWrapMain>
                          <AdressInfoWrap>
                            <AdressInfoInner>
                              <KeyStyle lineHeight="1.5">
                                {val.addresstype}:
                              </KeyStyle>
                              {val.primary ? (
                                <div>
                                  <GhostButtonComponentStyles>
                                    PRIMARY
                                  </GhostButtonComponentStyles>
                                </div>
                              ) : null}{" "}
                            </AdressInfoInner>
                            <div>
                              <ValueStyle lineHeight="1.5">
                                {val.line1},
                              </ValueStyle>
                            </div>
                            {val.line2 ? (
                              <div>
                                <ValueStyle lineHeight="1.5">
                                  {val.line2},
                                </ValueStyle>
                              </div>
                            ) : null}
                            {val.line3 ? (
                              <div>
                                <ValueStyle lineHeight="1.5">
                                  {val.line3},
                                </ValueStyle>
                              </div>
                            ) : null}
                            <div>
                              <ValueStyle lineHeight="1.5">
                                {val.city},
                              </ValueStyle>
                              &nbsp;
                              <ValueStyle lineHeight="1.5">
                                {val.state}
                              </ValueStyle>
                              &nbsp;
                              <ValueStyle lineHeight="1.5">
                                {val.zipcode},
                              </ValueStyle>
                            </div>
                            <div>
                              <ValueStyle lineHeight="1.5">
                                {getValues(val.country, "country")}
                              </ValueStyle>
                            </div>
                          </AdressInfoWrap>
                        </PhoneInfoWrapMain>
                      </Col>
                    );
                  }
                })
              : null}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  ...DetailsDerivedStates(state.toJS())
});


Details.propTypes = {
  addressInfo: CustomPropTypes.addressInfo,
  basicInfo: CustomPropTypes.basicInfo,
  countryDropdown: CustomPropTypes.basicImports,
  dispatch: PropTypes.func,
  emailInfo: CustomPropTypes.basicEmailInfo,
  genderDropdown: CustomPropTypes.basicImports,
  header: PropTypes.string,
  isSecondary: PropTypes.any,
  phoneInfo: CustomPropTypes.basicPhoneInfo,
  relatedContributorInfo: PropTypes.any,
  relationshipDropdown: CustomPropTypes.basicImports,
  suffixDropdown: CustomPropTypes.basicImports,
  titleDropdown: CustomPropTypes.basicImports,
}

export default connect(mapStateToProps)(Details);
